import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import logo from "../../resources/images/log.png";
import signature from "../../resources/images/signature.jpeg";
async function toBase64(url) {
  try {
    const response = await fetch(url, { mode: "cors" }); // Ensure CORS is enabled
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
    });
  } catch (error) {
    console.error("Error converting image to Base64:", error);
    return null;
  }
}

export const generateCertificatePDF = async (participant, courseDetails) => {
  const { name, designation, photo } = participant;
  const { courseName, courseStartDate, courseEndDate, venue, course, address } =
    courseDetails;

  // Ensure photo URL is valid and remove unnecessary query params
  const candidateImg = photo?.split("?")[0] || "";

  // Convert image URLs to Base64
  const base64CandidateImg = candidateImg ? await toBase64(candidateImg) : null;
  const base64Logo = await toBase64(logo);

  const certificateElement = document.createElement("div");
  certificateElement.style.width = "800px";
  certificateElement.style.height = "1123px";
  certificateElement.style.padding = "20px";
  certificateElement.style.textAlign = "center";
  certificateElement.style.fontFamily = "Arial, sans-serif";

  certificateElement.innerHTML = `
    <div style="border: 10px solid gold; padding: 20px; position: relative;">
      <div style="display:flex;justify-content:space-between; margin-bottom:100px">
        ${
          base64CandidateImg
            ? `<img src="${base64CandidateImg}" alt="Participant Photo" style="width: 100px;"/>`
            : ""
        }
        ${
          base64Logo
            ? `<img src="${base64Logo}" alt="Simpsons Logo" style="width: 180px;"/>`
            : ""
        }
      </div>
      <h1 style="color: #004aad; font-family: math; font-size: 40px; ">Certificate</h1>
      <p style="font-size:20px; font-style:italic; font-weight:500;margin-bottom:0px">This is to certify that</p>
      <h2 style="font-weight: 600;font-size:23px; margin-top:10px; font-style:italic">${name} (${designation})</h2>
       <p style="font-size:20px; font-style:italic; font-weight:500;margin-bottom:0px">has attended the Simpson Product Training on</p>
        <p style="font-size:20px; font-style:italic; font-weight:500;margin-bottom:0px">Simpson Engine(s) Model <b>${
          course.model
        }</b></p>
      <p style="font-size:20px; font-style:italic; font-weight:500;margin-bottom:0px">from <b>${courseStartDate}</b> to <b>${courseEndDate}</b></p>
      <p style="font-size:20px; font-style:italic; font-weight:500;margin-bottom:0px">at <b>${venue}</b></p>
      <p style="font-size:20px; font-style:italic; font-weight:500;margin-bottom:0px">${
        address.city
      } - ${address.state}</p>
      <div style="margin-top: 200px; display: flex; justify-content: space-around;">
        ${
          base64Logo
            ? `<img src="${signature}" alt="Signatures" style="width: 100%;"/>`
            : ""
        }
      </div>
    </div>
  `;

  document.body.appendChild(certificateElement);

  // Convert the certificate to an image
  const canvas = await html2canvas(certificateElement, { useCORS: true });
  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF("p", "mm", "a4");

  const imgWidth = 210; // A4 width in mm (portrait)
  const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

  pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
  pdf.save(`${name}_certificate.pdf`);
  document.body.removeChild(certificateElement);
};
